import { PropTypes } from 'prop-types';
import React, { useState, useEffect, useCallback } from 'react';

import { getPreviewStudy } from '../../../../core/services/projects';
import BasePreviewStudy from '../../../../core/components/base-preview-study';

const ProjectPreviewStudy = ({ match }) => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [project, setProject] = useState(null);

  const setPreviewStudy = useCallback(async () => {
    const { params } = match;
    const { projectId } = params;

    try {
      const previewStudy = await getPreviewStudy(projectId);

      setIsLoading(false);
      setProject(previewStudy);
    } catch (err) {
      setError(true);
      setIsLoading(false);
    }
  }, [match, setIsLoading, setProject, setError]);

  useEffect(() => {
    setPreviewStudy();
  }, []);

  return (
    <BasePreviewStudy
      questionSource={project || {}}
      error={error}
      loading={isLoading}
    />
  );
};

ProjectPreviewStudy.propTypes = {
  match: PropTypes.shape().isRequired,
};

export default ProjectPreviewStudy;
